module.exports = "<svg ng-if=\"$ctrl.data.hasBackground\" width=\"{{$ctrl.data.background.width}}\" height=\"{{$ctrl.data.background.height}}\" class=\"donut-bkg\">\n  <circle cx=\"{{$ctrl.data.background.cx}}\" cy=\"{{$ctrl.data.background.cy}}\" r=\"{{$ctrl.data.background.r}}\" stroke=\"{{$ctrl.data.background.stroke}}\" stroke-width=\"{{$ctrl.data.background.strokeWidth}}\" fill=\"none\"></circle>\n</svg>\n<donut-chart data=\"$ctrl.data.params\" text=\"$ctrl.data.text\"></donut-chart>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpDonutChart/adpDonutChart.html
// module id = 675
// module chunks = 0